export var ACTION;
(function (ACTION) {
    ACTION["CONTACT_US"] = "CONTACT_US";
    ACTION["PROFILE"] = "PROFILE";
    ACTION["FAQ"] = "FAQ";
    ACTION["BACK_BUTTON"] = "BACK_BUTTON";
    ACTION["ABOUT"] = "ABOUT";
    ACTION["LOGOUT"] = "LOGOUT";
    ACTION["FORECLOSE"] = "FORECLOSE";
    ACTION["LOAN_PROFILE"] = "LOAN_PROFILE";
    ACTION["TRACK_FORECLOSURE"] = "TRACK_FORECLOSURE";
    ACTION["HELP_AND_SUPPORT"] = "HELP_AND_SUPPORT";
})(ACTION || (ACTION = {}));
